// extracted by mini-css-extract-plugin
export default {"Card":"card_Card__1WwlP","LightHover":"card_LightHover__b2m-5","DarkHover":"card_DarkHover__MgJJ7"};